import { Module } from '@/modules/app/types';

export const isCommissioningSubModule = (nav: Module) =>
  ['commissioning_setup', 'commissioning_gate', 'commissioning_spline'].includes(nav);

export const CANVAS_MODULES = [
  'canvas_setup',
  'canvas_layout',
  'canvas_simulation',
  'canvas_viewer',
  'visualization',
] as const;

export type CanvasModule = (typeof CANVAS_MODULES)[number];

export const isCanvasModule = (m: Module): m is CanvasModule =>
  CANVAS_MODULES.some((x): x is CanvasModule => x === m);

const THREE_DIMENSION_WORKSPACE = ['visualization', 'canvas_viewer'];
export const is3dWorkspace = (nav: Module) => THREE_DIMENSION_WORKSPACE.includes(nav);
